import { Divider, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import CallIcon from '@material-ui/icons/Call'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'

import { gregorianToJalaali } from '../../../../helpers/date'
import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate } from '../../../../localization'
import { CancelRoomStayInfo } from '../../../../types/cancelReservationTAPanel'
import { useStyles } from './styles/index.styles'

type RoomStayInformationProps = {
  room: CancelRoomStayInfo
}

const RoomStayInformationForCancel: React.FC<RoomStayInformationProps> = ({
  room
}: RoomStayInformationProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <div className={classes.container}>
      <div className={classes.roomHeader}>
        <Typography
          variant="subtitle1"
          className={classes.verticalAlign}
          gutterBottom>
          <MeetingRoomIcon
            fontSize="small"
            style={{ marginRight: 4, fontSize: 20 }}
          />
          {`${room.roomTypeName} ${room.displayRoomTypeCode} ${room.displayRatePlanCode} `}
        </Typography>
      </div>
      <Divider />
      <div className={classes.roomDetails}>
        {room.guests.length > 0 && (
          <Typography variant="h5" className={classes.subSectionTitle}>
            {getTranslate('Guest Details')}
          </Typography>
        )}

        {room.guests.map((g, index) => (
          <div className={classes.personCard} key={index}>
            <div className={classes.row}>
              <AccountCircleIcon className={classes.profileIcon} />
              <Typography variant="h5" className={classes.blackText}>
                {` ${getTranslate('Guest')} ${index + 1}`}
              </Typography>
            </div>
            <div className={classes.detailsBox}>
              <div className={classes.row}>
                {isMobile ? (
                  <PersonOutlineIcon className={classes.formIcon} />
                ) : (
                  <Typography variant="h5" className={classes.blackText}>
                    {`${getTranslate('Name')}: `} &nbsp;
                  </Typography>
                )}

                <Typography variant="h5" className={classes.blackText}>
                  {g.name}
                </Typography>
              </div>
              <div className={classes.row}>
                {isMobile ? (
                  <MailOutlineIcon className={classes.formIcon} />
                ) : (
                  <Typography variant="h5" className={classes.blackText}>
                    {`${getTranslate('Email')}: `} &nbsp;
                  </Typography>
                )}
                <Typography variant="h5" className={classes.blackText}>
                  {g.email}
                </Typography>
              </div>
              <div className={classes.row}>
                {isMobile ? (
                  <CallIcon className={classes.formIcon} />
                ) : (
                  <Typography variant="h5" className={classes.blackText}>
                    {`${getTranslate('Mobile')}: `} &nbsp;
                  </Typography>
                )}
                <Typography variant="h5" className={classes.blackText}>
                  {g.mobile}
                </Typography>
              </div>
            </div>
          </div>
        ))}

        <Typography variant="h5" className={classes.subSectionTitle}>
          {getTranslate('Details')}
        </Typography>
        <div className={classes.scrollWrapper}>
          <div className={classes.scrollRow}>
            <div className={classes.table}>
              <div className={classes.tableHeader}>
                <Typography variant="h5" className={classes.cell}>
                  {getTranslate('Room')}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {getTranslate('Guests')}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {getTranslate('Extra Beds')}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {getTranslate('Check In')}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {getTranslate('Check Out')}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {getTranslate('Status')}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {getTranslate('Original Price')}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {getTranslate('Penalty')}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {getTranslate(room.payable > 0 ? 'Pay Back' : 'Pay ')}
                </Typography>
              </div>
              <div className={classes.tableRow}>
                <Typography variant="h5" className={classes.cell}>
                  {room.roomTypeName}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {room.numberOfGuests}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {room.numberOfChildren}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {gregorianToJalaali(room.checkIn)}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {gregorianToJalaali(room.checkOut)}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {room.status}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {`${addCommaToPrice(room.oldPrice)} ${getTranslate(
                    room.currency || ''
                  )}`}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {`${addCommaToPrice(room.penalty)} ${getTranslate(
                    room.currency || ''
                  )}`}
                </Typography>
                <Typography variant="h5" className={classes.cell}>
                  {`${addCommaToPrice(Math.abs(room.payable))} ${getTranslate(
                    room.currency || ''
                  )}`}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoomStayInformationForCancel
